<template>
    <div class="ticket-packages-filter">
        <div class="container">
            <div class="inner">
                <button class="button-filter" @click="toggleDrawer">
                    <svg-icon name="filter" />
                    <span>{{ trans.filters.filters }}</span>
                </button>

                <multi-select-form
                    id="dates"
                    :placeholder="trans.filters.dates"
                    :value="filters.dates"
                    @change="value => handleChange(value, 'dates')"
                    :options="
                        filterOptions.dates.map(date => ({
                            label: `${date.date} - ${date.group}`,
                            value: date.value
                        }))
                    "
                />
                <multi-select-form
                    id="type"
                    :placeholder="trans.filters.types"
                    :value="filters.types"
                    @change="value => handleChange(value, 'types')"
                    :options="filterOptions.types"
                />
                <!-- <multi-select-form
                    id="price"
                    :placeholder="trans.filters.prices"
                    :value="filters.prices"
                    @change="value => handleChange(value, 'prices')"
                    :options="filterOptions.prices"
                /> -->
                <multi-select-form
                    id="inclusions"
                    :placeholder="trans.filters.includes"
                    :value="filters.inclusions"
                    @change="value => handleChange(value, 'inclusions')"
                    :options="filterOptions.inclusions"
                />

                <div
                    class="promocode-group"
                    :class="{ applied: promocodeApplied }"
                    v-if="config.allow_promocode"
                >
                    <form @submit.prevent="submitPromocode">
                        <input
                            class="promocode-input"
                            type="text"
                            v-model="promocode"
                            @input="() => (promocodeApplied = false)"
                            :placeholder="trans.promocode.input"
                            autocomplete="off"
                        />
                        <button
                            type="submit"
                            class="promocode-button"
                            :disabled="loading"
                        >
                            {{
                                loading
                                    ? "..."
                                    : promocodeApplied
                                    ? trans.promocode.applied
                                    : trans.promocode.apply
                            }}
                        </button>
                    </form>
                </div>
            </div>
        </div>

        <ticket-packages-filter-drawer
            :is-open="isOpen"
            :filters="filters"
            :filter-options="filterOptions"
            @toggle-drawer="toggleDrawer"
            @filter-change="handleDrawerChange"
            :total-tickets="totalTickets"
            :trans="trans"
        />
    </div>
</template>

<script>
import MultiSelectForm from "../../form/MultiSelectForm.vue";
import SelectForm from "../../form/SelectForm.vue";
import TicketPackagesFilterDrawer from "./TicketPackagesFilterDrawer.vue";
import {
    trackCouponDenied,
    trackFilterTickets,
    trackSelectPromotion
} from "../../../utils/gtm";

export default {
    components: {
        SelectForm,
        MultiSelectForm,
        TicketPackagesFilterDrawer
    },
    props: {
        filters: {
            type: Object,
            default: () => ({
                dates: [],
                types: [],
                prices: [],
                inclusions: []
            })
        },
        filterOptions: {
            type: Object,
            default: () => ({
                dates: [],
                types: [],
                prices: [],
                inclusions: []
            })
        },
        totalTickets: {
            type: Number,
            required: true
        },
        config: {
            type: Object,
            required: true,
        },
        trans: {
            type: Object,
            required: true
        }
    },
    data() {
        return {
            isOpen: false,
            loading: false,
            promocode: "",
            promocodeApplied: false,
            promocodeData: null,
            locationsWithoutPromoCode: [
                "luxury-suite",
                "folia-tropical",
                "super-folia",
                "camarote-maravilha"
            ],
        };
    },
    mounted() {
        const fromUrl = this.getPromocodeFromQuery();
        if (fromUrl && this.config.allow_promocode) {
            this.promocode = fromUrl;
            this.submitPromocode();
            return;
        }

        this.loadPromocodeFromStorage();
    },
    methods: {
        getPromocodeFromQuery() {
            const raw = new URLSearchParams(window.location.search).get(
                "promocode"
            );
            if (raw && raw.trim()) return raw.trim();
            try {
                const quiz = JSON.parse(sessionStorage.getItem("quizPromocode") || "null");
                if (quiz && quiz.promocode) return String(quiz.promocode).trim();
            } catch (e) {
                /* ignore */
            }
            return null;
        },
        handleChange(value, type) {
            const prev = this.filters[type] || [];
            const next = Array.isArray(value) ? value : value != null ? [value] : [];
            const added = next.filter(v => !prev.includes(v));
            const removed = prev.filter(v => !next.includes(v));

            added.forEach(v => {
                const opt = ((this.filterOptions[type] || []).find(
                    o => o.value === v
                ) || {});
                trackFilterTickets({
                    filter_source: "dropdown",
                    filter_action: "select",
                    filter_type: type,
                    filter_value: v,
                    location_id: type === "types" ? v : null,
                    location_name:
                        type === "types" ? opt.label || v : null
                });
            });
            removed.forEach(v => {
                const opt = ((this.filterOptions[type] || []).find(
                    o => o.value === v
                ) || {});
                trackFilterTickets({
                    filter_source: "dropdown",
                    filter_action: "deselect",
                    filter_type: type,
                    filter_value: v,
                    location_id: type === "types" ? v : null,
                    location_name:
                        type === "types" ? opt.label || v : null
                });
            });

            this.$emit("filter-change", {
                ...this.filters,
                [type]: value
            });
        },
        handleDrawerChange(updatedFilters) {
            ["dates", "types", "prices", "inclusions"].forEach(type => {
                if (!Object.prototype.hasOwnProperty.call(updatedFilters, type)) {
                    return;
                }
                const prev = this.filters[type] || [];
                const next = updatedFilters[type] || [];
                const added = next.filter(v => !prev.includes(v));
                const removed = prev.filter(v => !next.includes(v));
                added.forEach(v => {
                    trackFilterTickets({
                        filter_source: "dropdown",
                        filter_action: "select",
                        filter_type: type,
                        filter_value: v,
                        location_id: type === "types" ? v : null
                    });
                });
                removed.forEach(v => {
                    trackFilterTickets({
                        filter_source: "dropdown",
                        filter_action: "deselect",
                        filter_type: type,
                        filter_value: v,
                        location_id: type === "types" ? v : null
                    });
                });
            });
            this.$emit("filter-change", updatedFilters);
        },
        applyFilters() {
            this.$emit("filter-change", this.filters);
        },
        toggleDrawer() {
            this.isOpen = !this.isOpen;
            this.$emit("filter-open", this.isOpen);
        },
        submitPromocode() {
            this.loading = true;
            const request = axios.get("/api/promocode", {
                params: {
                    promocode: this.promocode,
                    site: this.trans.domain.site
                }
            });
            request
                .then(({ data }) => {
                    this.loading = false;

                    // Local/dev soft preview from quiz codes when shop is unreachable.
                    if (
                        (!data.tickets || data.tickets.length === 0) &&
                        !data.soft
                    ) {
                        window.toast.error(this.trans.promocode.invalid);
                        trackCouponDenied({
                            coupon: this.promocode,
                            reason: "invalid"
                        });
                        this.clearPromocode();
                        return this.$emit("promocode-change", null);
                    }

                    this.promocodeApplied = true;
                    this.promocodeData = {
                        promocode: this.promocode,
                        ...data
                    };

                    this.savePromocodeToStorage(this.promocodeData);
                    window.eventBus.$emit("fetch-endpoint-with-token");

                    trackSelectPromotion({
                        coupon: this.promocode,
                        promo_type: data.promo_type || null
                    });

                    window.toast.success(this.trans.promocode.success);

                    return this.$emit("promocode-change", this.promocodeData);
                })
                .catch(_error => {
                    this.loading = false;
                    trackCouponDenied({
                        coupon: this.promocode,
                        reason: "error"
                    });
                    window.toast.error(this.trans.promocode.error);
                });
        },
        savePromocodeToStorage(promocodeData) {
            try {
                sessionStorage.setItem(
                    "promocodeData",
                    JSON.stringify(promocodeData)
                );
            } catch (error) {
                console.warn(
                    "Failed to save promocode to sessionStorage:",
                    error
                );
            }
        },
        loadPromocodeFromStorage() {
            try {
                const storedData = sessionStorage.getItem("promocodeData");
                if (storedData) {
                    const promocodeData = JSON.parse(storedData);
                    this.promocodeData = promocodeData;
                    this.promocode = promocodeData.promocode;
                    this.promocodeApplied = true;

                    this.$emit("promocode-change", promocodeData);
                }
            } catch (error) {
                console.warn(
                    "Failed to load promocode from sessionStorage:",
                    error
                );
            }
        },
        clearPromocode() {
            this.promocode = "";
            this.promocodeApplied = false;
            this.promocodeData = null;
            sessionStorage.removeItem("promocodeData");
            this.$emit("promocode-change", null);
        }
    }
};
</script>
